const BRAZIL_COUNTRY_CODE = '55';
const BRAZIL_LENGTHS = [12, 13];

export function formatPhone(value) {
  const raw = String(value ?? '').trim();
  const digits = raw.replace(/\D/g, '');
  if (!digits.startsWith(BRAZIL_COUNTRY_CODE) || !BRAZIL_LENGTHS.includes(digits.length)) {
    return raw;
  }
  const areaCode = digits.slice(2, 4);
  const number = digits.slice(4);
  const split = number.length - 4;
  return `+55 ${areaCode} ${number.slice(0, split)}-${number.slice(split)}`;
}
